// /track: order number + email + mobile → the order page (all three must match on the server).
import { $, api, t } from "./util";

const KEY = "darat_track";

export function initLookup() {
	const form = $("[data-track-form]");
	if (!form) return;
	try {
		const saved = JSON.parse(localStorage.getItem(KEY) || "null");
		if (saved) ["id:order_id", "email:email", "mobile:mobile"].forEach((m) => {
			const [k, name] = m.split(":");
			if (saved[k]) form.elements[name].value = saved[k];
		});
	} catch (e) { /* private mode */ }

	form.addEventListener("submit", async (e) => {
		e.preventDefault();
		const err = $("[data-err]", form), btn = $("button[type=submit]", form);
		const fd = Object.fromEntries(new FormData(form).entries());
		const data = {
			order_id: (fd.order_id || "").trim().toUpperCase(),
			email: (fd.email || "").trim(),
			mobile: (fd.mobile || "").replace(/[\s-]/g, "").replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d)),
			website: fd.website || "",
		};
		err.hidden = true;
		if (!data.order_id || !data.email || !data.mobile) {
			err.textContent = t("أدخل رقم الطلب والبريد الإلكتروني ورقم الجوال", "Enter the order number, email and mobile number");
			err.hidden = false;
			return;
		}
		btn.disabled = true; btn.classList.add("is-loading");
		try {
			const res = await api("darat.storefront.api.track_order", data, "POST");
			try {
				if (fd.remember) localStorage.setItem(KEY, JSON.stringify({ id: data.order_id, email: data.email, mobile: data.mobile }));
				else localStorage.removeItem(KEY);
			} catch (e2) { /* private mode */ }
			location.href = res.url;
		} catch (ex) {
			err.textContent = ex.message; err.hidden = false;
			btn.disabled = false; btn.classList.remove("is-loading");
		}
	});
}
